import { render, staticRenderFns } from "./IntegrationSettings.vue?vue&type=template&id=3452c2ac&scoped=true"
import script from "./IntegrationSettings.vue?vue&type=script&lang=js"
export * from "./IntegrationSettings.vue?vue&type=script&lang=js"
import style0 from "./IntegrationSettings.vue?vue&type=style&index=0&id=3452c2ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3452c2ac",
  null
  
)

export default component.exports